import { createStore } from "vuex";
import configure from "./configure";
import user from "./user";
import song from "./song";
import play from './modules/play';
import createPersistedState from "vuex-plugin-persistedstate";

export default createStore({
  modules: {
    configure,
    user,
    song,
    play,
  },
  plugins: [createPersistedState()] // 默认使用 localStorage
});
